import { useGlobalPeriod } from "@iliotech/data-wire";

import { usePortfolio } from "@iliotech/data-wire";
import moment from "moment";
import { useEffect, useState } from "react";

export const useReportPeriod = (portfolioId: string) => {
  const portfolioRequest = usePortfolio(portfolioId);
  const portfolioInfo = portfolioRequest.data?.data;
  const inceptionDate = portfolioInfo?.inceptionDate;
  const { setPeriod, period } = useGlobalPeriod();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!inceptionDate) return;
    const today = moment();
    const portfolioLifeTimeInDays = moment(today).diff(
      moment(inceptionDate),
      "days"
    );
    if (portfolioLifeTimeInDays > 365) {
      setPeriod({
        from: moment(today).subtract(1, "year").add(1, "day").toDate(),
        to: moment(today).toDate(),
        label: "1 Year",
      });
      setLoaded(true);
    } else {
      setPeriod({
        from: moment(inceptionDate).toDate(),
        to: moment().startOf("day").set({ hours: 3 }).toDate(),
        label: "All",
      });
      setLoaded(true);
    }
  }, [inceptionDate, setPeriod]);

  return { loaded, period };
};
